<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">

        <CoachingOverviewData :coaching="coachingData"/>

        <Menu :coaching="coachingData" :currentUser="piniaCurrentUser"/>

        <form v-if="isLoaded" @submit.prevent="submitForm" novalidate class="container-fluid py-3 px-lg-4">

          <div class="text-center mt-4 mb-4">
            <h5>Dokumente</h5>
          </div>

          <div class="card shadow-sm border-0 mb-4">
            <div class="card-header bg-light border-bottom-0 py-3">
              <h6 class="mb-0 fw-bold text-secondary">Abschlussbericht & Rechnung</h6>
            </div>

            <div class="card-body p-4">
              <div class="row align-items-center mb-1 pb-2 border-bottom-sm">
                <div class="col-12 col-md-5 col-lg-3">
                  <BaseCheckbox
                      v-model="formData.reportCreated"
                      label="Abschlussbericht erstellt"
                      labelPosition="right"
                      class="fw-bold m-0"/>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                  <transition name="fade">
                    <div v-if="formData.reportCreated">
                      <Datepicker
                          v-model="formData.reportCreatedDate"
                          :required="true"
                          :validation="v$?.reportCreatedDate"
                          :messages="v$?.reportCreatedDate?.required?.$message"
                          class="m-0 shadow-sm"/>
                    </div>
                  </transition>
                </div>

                <div class="col-12 col-sm-6 col-md-3 col-lg-4" v-if="formData.reportCreated">
                  <span class="text-faded p-2 mt-1">
                      Datum der Erstellung des Abschlussberichts
                  </span>
                </div>
              </div>

              <div class="row align-items-center mb-1 pb-2 border-bottom-sm">
                <div class="col-12 col-md-5 col-lg-3">
                  <BaseCheckbox
                      v-model="formData.reportSent"
                      label="Abschlussbericht versendet"
                      labelPosition="right"
                      class="mb-md-0 mb-2"/>
                </div>

                <div class="col-12 col-md-4 col-lg-2">
                  <transition name="fade">
                    <Datepicker
                        v-if="formData.reportSent"
                        v-model="formData.reportSentDate"
                        :required="true"
                        :validation="v$?.reportSentDate"
                        :messages="v$?.reportSentDate?.required?.$message"
                        class="shadow-sm"/>
                  </transition>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-4" v-if="formData.reportSent">
                   <span class="text-faded p-2 mt-1">
                     Datum des Versands des Abschlussberichts
                  </span>
                </div>
              </div>

              <div class="row align-items-center">
                <div class="col-12 col-md-5 col-lg-3">
                  <BaseCheckbox
                      v-model="formData.billCreated"
                      label="Rechnung erstellt"
                      labelPosition="right"
                      :disabled="true"
                      class="mb-md-0 mb-2"/>
                </div>

                <div class="col-12 col-md-4 col-lg-3">
                   <span
                       v-for="(date, index) in billDates"
                       :key="index"
                       style="margin-right: 8px;">
                    {{ date }}<span v-if="index !== billDates.length - 1">,</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow-sm border-0 mb-4">
            <div class="card-header bg-light border-bottom-0 py-3">
              <h6 class="mb-0 fw-bold text-secondary">Dokumente</h6>
            </div>

            <div class="card-body p-4">
              <div class="row g-3">
                <div class="col-12 col-sm-6 col-md-3">
                  <div class=" bg-white h-100 d-flex align-items-center shadow-xs">
                    <BaseCheckbox
                        v-model="formData.needsAnalysis"
                        label="Bedarfsanalyse"
                        labelPosition="right"
                        class="m-0"/>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                  <div class="p-3 bg-white h-100 d-flex align-items-center shadow-xs">
                    <BaseCheckbox
                        v-model="formData.recommendationLetter"
                        label="Empfehlungsschreiben"
                        labelPosition="right"
                        class="m-0"/>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                  <div class="p-3 bg-white h-100 d-flex align-items-center shadow-xs">
                    <BaseCheckbox
                        v-model="formData.confidentialityRelease"
                        label="Schweigepflichtsentbindung"
                        labelPosition="right"
                        class="m-0"/>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                  <div class="p-3  bg-white h-100 d-flex align-items-center shadow-xs">
                    <BaseCheckbox
                        v-model="formData.privacyPolicy"
                        label="Datenschutzerklärung"
                        labelPosition="right"
                        class="m-0"/>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="card shadow-sm border-0 mb-4">
            <div class="card-header bg-light border-bottom-0 py-3">
              <h6 class="mb-0 fw-bold text-secondary">BSG bekannt durch</h6>
            </div>
            <div class="card-body p-4">
              <div class="row align-items-start">
                <div class="col-12 col-md-10 col-lg-8">
                  <div class="d-flex flex-column gap-2">
                    <BaseCheckbox
                        v-model="formData.clerk"
                        label="Sachbearbeiter"
                        :labelPosition="'right'"
                        class="pb-2 border-bottom-sm"/>

                    <BaseCheckbox
                        v-model="formData.courseNet"
                        label="Kursnet"
                        :labelPosition="'right'"
                        class="pb-2 border-bottom-sm"/>

                    <BaseCheckbox
                        v-model="formData.recommendationFromOtherParticipants"
                        label="Empfehlung od drugih učesnika"
                        :labelPosition="'right'"
                        class="pb-2 border-bottom-sm"/>

                    <BaseCheckbox
                        v-model="formData.socialMedia"
                        label="Social Media"
                        :labelPosition="'right'"
                        class="pb-2 border-bottom-sm"/>

                    <div class="pt-1">
                      <BaseCheckbox
                          v-model="formData.others"
                          label="Sonstiges"
                          :labelPosition="'right'"
                          class="pb-2"/>

                      <transition name="fade">
                        <div v-if="formData.others" class="ms-4 ps-2 mt-2">
                          <BaseInput
                              v-model="formData.othersDescription"
                              :validation="v$?.othersDescription"
                              :messages="v$?.othersDescription?.required?.$message"
                              placeholder="Bitte beschreiben..."/>
                        </div>
                      </transition>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center w-100 mt-4">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>

      </div>
    </div>
  </PageTemplate>
</template>

<script setup lang="ts">
import {computed, onMounted, reactive, ref, watch} from 'vue'
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import Datepicker from "@/components/picker/Datepicker.vue";
import PageTemplate from "@/components/PageTemplate.vue";
import Menu from "@/views/App/Portal/CaseManagementCoaching/Menu.vue";
import Loader from "@/components/Loader.vue";
import CoachingOverviewData from "@/views/App/Portal/CaseManagementCoaching/CoachingOverviewData.vue";
import {piniaUserStore} from "@/store/piniaUserStore";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";
import {CloseToast, ErrorToast, SuccessToast} from "@/components/VueToast";
import portalService from "@/api/Unemployed/CaseManagementCoaching";
import {requiredRule} from "@/shared/validators/validationRules";
import useVuelidate from "@vuelidate/core";
import BaseInput from "@/components/base/BaseInput.vue";
import portalCoachingService from "@/api/Portal/CaseManagementCoaching";
import SaveButton from '@/components/button/SaveButton.vue';

const {t} = useI18n();
const route = useRoute();
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const isLoaded = ref(false);
const isSubmitting = ref(false);
const coachingData = ref('');
const coachingId = +route.params.id;

type NullableDate = string | null

interface BillCreatedDate {
  billDate: string;
  billNumber: string;
}

interface FormData {
  coachingId: number;
  reportCreated: boolean
  reportCreatedDate: NullableDate

  reportSent: boolean
  reportSentDate: NullableDate

  billCreated: boolean
  billCreatedDates: BillCreatedDate[]

  needsAnalysis: boolean
  recommendationLetter: boolean
  confidentialityRelease: boolean
  privacyPolicy: boolean

  clerk: boolean,
  courseNet: boolean,
  recommendationFromOtherParticipants: boolean,
  socialMedia: boolean,
  others: boolean,
  othersDescription: string,
}


const formData = reactive<FormData>({
  coachingId: 0,
  reportCreated: false,
  reportCreatedDate: null,

  reportSent: false,
  reportSentDate: null,

  billCreated: false,
  billCreatedDates: [],

  needsAnalysis: false,
  recommendationLetter: false,
  confidentialityRelease: false,
  privacyPolicy: false,

  clerk: false,
  courseNet: false,
  recommendationFromOtherParticipants: false,
  socialMedia: false,
  others: false,
  othersDescription: '',
})

const billDates = computed(() => (formData.billCreatedDates ?? []).map(item => item.billDate));

const formRules = ref({});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.coachingId = +coachingId;
    await portalCoachingService.submitDocuments(formData);

    await getDocumentsData();

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getCoachingData() {
  try {
    CloseToast();
    const {data} = await portalService.getCaseManagementCoaching(+coachingId);

    coachingData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getDocumentsData() {
  try {
    const {data} = await portalCoachingService.getDocuments(+coachingId);
    Object.assign(formData, {
      ...data.data,
    });
  } catch (error) {
    await ErrorToast(error);
  }
}

watch(() => formData.reportCreated, (val) => {
  if (!val) {
    formData.reportCreatedDate = null
    formRules.value = {...formRules.value, reportCreatedDate: ''};
  } else {
    formRules.value = {...formRules.value, reportCreatedDate: requiredRule(t)};
  }
})

watch(() => formData.reportSent, (val) => {
  if (!val) {
    formData.reportSentDate = null
    formRules.value = {...formRules.value, reportSentDate: ''};
  } else {
    formRules.value = {...formRules.value, reportSentDate: requiredRule(t)};
  }
})

watch(
    () => formData.others,
    (value: boolean) => {
      if (value) {
        formRules.value = {...formRules.value, othersDescription: requiredRule(t),}
      } else {
        formData.othersDescription = ''
        formRules.value = {...formRules.value, othersDescription: '',}
      }
    }
)


onMounted(async () => {
  await Promise.all([
    getCoachingData(),
    getDocumentsData()
  ]);

  isLoaded.value = true;
});
</script>


<style scoped>
</style>